import { FC } from 'react';
import { Box, Link, Text, VStack } from '@chakra-ui/react';

import SunshineCard from 'components/_core/SunshineCard';
import { formatAddress } from 'helpers/address';

import { ExternalCompanyProfileInfo } from '../../../../types';
import locales from './locales';

interface ResultsProps {
  companies: ExternalCompanyProfileInfo[];
  onSelectCompany: (externalCompany: ExternalCompanyProfileInfo) => void;
  onSkip: () => void;
}

const Results: FC<ResultsProps> = ({ companies, onSelectCompany, onSkip }) => (
  <VStack alignItems="stretch" spacing="space-24">
    <SunshineCard.Group>
      {companies.map((company) => (
        <SunshineCard
          data-testid="results-item"
          key={company.legalRegistrationNumber}
          onClick={() => onSelectCompany(company)}
          title={company.legalName ?? ''}
        >
          <SunshineCard.Content>
            <SunshineCard.Text>
              {formatAddress({
                city: company.city ?? '',
                street: company.street ?? '',
                zip: company.zip ?? '',
              })}
            </SunshineCard.Text>
          </SunshineCard.Content>

          <SunshineCard.Slot name="action">
            <SunshineCard.SunshineIcon name="chevron-right" />
          </SunshineCard.Slot>
        </SunshineCard>
      ))}
    </SunshineCard.Group>

    <Box textAlign="center">
      <Text>{locales.manualEntry.prompt}</Text>

      <Link as="button" marginBottom="space-16" onClick={onSkip}>
        {locales.manualEntry.cta}
      </Link>
    </Box>
  </VStack>
);

export default Results;
